import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation'
import { getOrganisationId } from 'lib/utils/common_utils'
import React, { useEffect, useState } from 'react'
import LineCustomerService from 'lib/services/api/admin/line/line_customer_client_new';
import PartSalesServices from 'lib/services/api/commercial/parts';
const status = [
    { name: "Status (Open)", value: "Open" },
    { name: "Quote", value: "quote" },
    { name: "In Progress", value: "In Progress" },
    { name: "Complete", value: "Complete" }
]

const salesType = [
    { name: "Sale Type (All)", value: "" },
    { name: "Sale Only", value: "Sale Only" },
    { name: "Sale & Core Return", value: "Sale & Core Return" }
]

const priority = [
    { value: "", name: "Priority (All)" },
    { name: "! MEDIUM", value: "medium" },
    { name: "!! HIGH", value: "high" }
]
const accountStatus = [

    { name: "Status (Ready)", value: "Ready" },
    { name: "All", value: "" },
    { name: "Quote", value: "Quote" },
    { name: "Pending", value: "Pending" }, { name: "In Repair", value: "In Repair" },
    { name: "Complete", value: "Complete" },
    { name: "Rejected", value: "Rejected" },
    { name: "Archived", value: "Archived" },



]

const commercialStatus = [

    { name: "Status (Open)", value: "Open" },
    { name: "All", value: "" },
    { name: "Quote", value: "Quote" },
    { name: "In Progress", value: "In Progress" },
    { name: "Complete", value: "Complete" },
    { name: "Rejected", value: "Rejected" },
    { name: "Archived", value: "Archived" },


]

const coreStatus = [
    { name: "Status (In Progress)", value: "In Progress" },
    { name: "All", value: "" },
    { name: "Quote", value: "Quote" },
    { name: "Pending", value: "Pending" },
    { name: "In Repair", value: "In Repair" },
    { name: "Complete", value: "Complete" },
    { name: "Rejected", value: "Rejected" },

]

const coreSubStatus = [
    { name: "Status (All)", value: "" },
    { name: "In Progress", value: "In Progress" },
    { name: "Quote", value: "Quote" },
    { name: "Pending", value: "Pending" },
    { name: "In Repair", value: "In Repair" },
    { name: "Complete", value: "Complete" },


]
const coreType = [

    { name: "Internal", value: "Internal" },
    { name: "External", value: "External" },

]

const coreDue = [

    { name: "> 7 Days", value: "> 7 Days" },
    { name: "< 7 Days", value: "< 7 Days" },
    { name: "Overdue", value: "Overdue" },

]
const coreCredit = [


    { name: "Pending", value: "Pending" },
    { name: "Credited", value: "Credited" },
    { name: "Paid", value: "Paid" },

]

const accountInvoices = [


    { name: "Invoiced (All)", value: "" },
    { name: "Pending", value: "Pending" },
    { name: "Invoiced", value: "Invoiced" },
    { name: "Paid", value: "Paid" },


]
function useGetFilterDetails() {
    const [bases, setBases] = useState([])
    const [customer, setCustomer] = useState([])
    // Fetch base stations for the filter
    useEffect(() => {
        const fetchData = async () => {
            const params = { organisation_id: getOrganisationId() };

            try {
                // Run both requests in parallel
                const [baseResponse, customerResponse] = await Promise.all([
                    MaintenanceServices.getBaseStation(params),
                    PartSalesServices.getCustomerList({ ...params, type: "all" }),
                ]);

                // Set base stations
                if (baseResponse?.data) {
                    const value =
                        baseResponse.data.map((base) => ({
                            id: base?.id,
                            name: base?.station,
                        })) || [];
                    setBases(value);
                }

                // Set customer list
                if (customerResponse?.data?.customers) {
                    setCustomer(customerResponse.data.customers);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    // console.log(bases)

    // Return filter options directly
    return {
        bases,
        status,
        sales: salesType,
        priority,
        accountStatus,
        accountInvoices,
        customerDetails: customer,
        commercialStatus,
        coreStatus,
        coreCredit,
        coreDue,
        coreType,
        coreSubStatus
    }
}

export default useGetFilterDetails